module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/sp-app-shell/',
  octopusPackageId: 'supplier-portal-app-shell',
  octopusProjectName: 'Supplier Portal App Shell',
  mountDOMId: '__sp-app-shell__',
  standalone: true
};